// extracted by mini-css-extract-plugin
export default {"wrap":"ErrorPage_wrap__doaMe","right":"ErrorPage_right__EkGoI","button":"ErrorPage_button__5DFqn","left":"ErrorPage_left__ZYra1","img":"ErrorPage_img__2-AJy"};